module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-Bold.1b817fd9.woff";